import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils.ts";

interface ScoreLabelConfig {
  label: string;
  className: string;
}

export const getScoreLabel = (score: number): ScoreLabelConfig => {
  if (score >= 4) {
    return { label: "HIGH", className: "text-green-400" };
  }
  if (score >= 2.5) {
    return { label: "MEDIUM", className: "text-primary" };
  }
  return { label: "LOW", className: "text-red-400" };
};

interface KpiDriverHeaderProps {
  title: string;
  score: number;
  isOpen: boolean;
  heatmapSubcategoryLabel?: string;
}

export default function KpiDriverHeader({
  title,
  score,
  isOpen,
  heatmapSubcategoryLabel,
}: KpiDriverHeaderProps) {
  const scoreConfig = getScoreLabel(score);

  return (
    <div className="flex items-center justify-between p-4 hover:bg-muted/50 transition-colors cursor-pointer">
      <div className="min-w-0 flex-1 pr-4 text-left">
        <div className="text-foreground break-words">{title}</div>
        {heatmapSubcategoryLabel ? (
          <div className="mt-1 text-xs font-medium text-muted-foreground">
            {heatmapSubcategoryLabel}
          </div>
        ) : null}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">
            {Math.round(score)}
          </div>
          <div className={cn("text-xs font-medium", scoreConfig.className)}>
            {scoreConfig.label}
          </div>
        </div>
        <ChevronDown
          className={cn(
            "h-5 w-5 text-muted-foreground transition-transform",
            isOpen && "rotate-180",
          )}
        />
      </div>
    </div>
  );
}
